module.exports = __webpack_public_path__ + "img/yikes.491d1c36.png";